"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var getUnreadNotificationsCount = function () {
    return (0, service_1.getService)()
        .get("/notifications/unread_count")
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
exports.default = getUnreadNotificationsCount;
